import { useReducer } from 'react';
import { GlobalContext } from './GlobalContext';

const initialState = {
    center: { lat: 24.7135517, lng: 46.6752957 },
    loader: true
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_LOADER':
            return {
                ...state,
                loader: action.payload
            }
        default:
            return state;
    }
}

export const GlobalProvider = props => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
        <GlobalContext.Provider value={{ state, dispatch }}>
            {props.children}
        </GlobalContext.Provider>
    )
}
